<template>
  <div class="detailsBox">

    <div class="topSearch">
      <!-- <van-icon name="arrow-left" @click="goHistroy" /> -->
      <!-- <van-search class="searchInput" v-model="questionObj.title" background="#fff" placeholder="请输入搜索关键词"
        @click="goSearch" /> -->
    </div>
    <div class="headerimg">
      <img src="../../static/image/header.png" alt="">
    </div>
    <!-- 内容区 -->
    <div class="contentBox">
      <div class="bgTit">
        <img src="../../static/image/qs.png" class="questionIcon" />
        <h4>
          {{ questionObj.title }}
        </h4>
      </div>
      <div class="content" v-if="questionObj.type == 2" v-html="questionObj.answer"></div>
      <div class="content" v-if="questionObj.type == 1">
        {{ questionObj.answer }}
      </div>
    </div>
    <div class="bottomText">基金有风险，投资须谨慎</div>
    <div class="banckbtn" @click="goback()">返回目录</div>
    <!-- <tab></tab> -->
  </div>
</template>

<script>
import { answerDetails2 } from "@/api/index";
// import tab from "@/components/tab";
export default {
  name: "details",
  components: {},
  data () {
    return {
      msg: "基金啊，这个相比理财，不是风险很大吗？",
      id: null,
      questionObj: {
        title: "",
        answer: "",
      },
    };
  },
  created () {
    this.id = this.$route.query.id;
    this.getDetails(this.id);
  },
  methods: {
    goHistroy () {
      this.$router.go(-1);
    },
    getDetails (id) {
      answerDetails2({ id: id, type: 1 })
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            // this.handleSpeak(res.data.top_news.title)
            // this.handleSpeak(res.data.top_news.answer)
            this.questionObj = res.data.top_news;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    goSearch () {
      this.$router.push({
        path: "/search",
        query: {
          msg: this.questionObj.title,
        },
      });
    },
    goback () {
      this.$router.push({
        path: "/zgyh/newindex",
      });
    }
  },
};
</script>
<style lang="less">
img {
  max-width: 100%;
  height: auto;
}
</style>
<style lang="less" scoped>
.detailsBox {
  box-sizing: border-box;
  overflow: hidden;
  // height: 100vh;
  background: url("../../static/image/bgimg.png");
  background-size: 100% 100%;
  // position: relative;
  width: 100%;
  // min-height: 100vh;
  // margin: 0 auto 2.5rem;
  padding-bottom: 3.5rem;

  .headerimg {
    margin: 0 auto;
    height: 160px;
    width: 375px;
    img {
      width: 100%;
    }
  }
  .topSearch {
    display: flex;
    align-items: center;
    .searchInput {
      flex: 2;
      margin-left: 0.625rem;
    }
  }
  .van-search {
    padding: 0.625rem 0;
  }
  .van-search__content {
    padding-left: 0;
    background: #fff;
  }
  .van-search .van-cell {
    line-height: 2rem;
    background: #f4f4f4;
    border-radius: 3.125rem;
    padding: 0 0.625rem;
    box-sizing: border-box;
  }
  .contentBox {
    // background: #fff;
    margin: 0.6rem auto;
    padding: 25px;
    border-radius: 0.9375rem;
    width: 90%;
    background: #fee9de;
    border: 1px solid #ff984e;
    box-shadow: 3px 3px 15px 0px #fee9d0;
    border-radius: 22px;
    height: auto;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12);
    // padding: 0.3125rem 0.9375rem;
    box-sizing: border-box;
    overflow: hidden;
    .bgTit {
      // padding: 0.3125rem 0.5rem;
      margin-bottom: 20px;
      display: flex;
      align-items: flex-start;
      line-height: 1.8625rem;
      // background: #f6f6f6;
      h4 {
        margin: 0;
        color: #ff8227ff;
        font-size: 18px;
        font-weight: 500;
      }
      .questionIcon {
        display: inline-block;
        width: 1.825rem;
        height: 1.825rem;
        margin-right: 0.5rem;
        margin-top: 0.08rem;
      }
    }
    .content {
      line-height: 1.5625rem;
      padding: 0.3125rem 0.9375rem;
      box-sizing: border-box;
      border-radius: 5px;
      background: #fff;
      width: 100%;
      padding: 20px;
      img {
        max-width: 12.5rem;
      }
    }
  }
  .bottomText {
    width: 100%;
    height: 50px;
    text-align: center;
    font-size: 0.75rem;
    color: #999;
  }
}
.banckbtn {
  width: 120px;
  height: 36px;
  color: #fff;
  line-height: 32px;
  font-weight: bold;
  margin: 0 auto;
  text-align: center;
  background: url("../../static/image/buton.png");
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/newdetail.vue